import styled from '@emotion/styled';

const Textarea = styled.textarea`
  width: ${props => (props.width ? props.width : 300)}px;
  height: ${props => (props.height ? props.height : 50)}px;
  border: 3px white solid;
  background: transparent;
  color: white;
  font-size: 19px;
  padding-left: 15px;
  padding-top: 15px;
  margin: 30px;
  
     @media (max-width: 768px) {
  width: 100%;
  }
  
    &:focus {
   border-color: #00FFFF;
   outline: none;
  }
  
     &:hover {
   border-color: #00FFFF;
   outline: none;
  }
`;

export default Textarea;
